/**
 * StatusBadge — renders a ProjectStatus with its locked-in color token.
 *
 * Color is by status — never by item type. See ADR-0010.
 */
import type { ProjectStatus } from '@vari-crew/schemas';
import { PROJECT_STATUS_LABELS } from '@vari-crew/schemas';
import { cn } from '@/lib/cn';

const STATUS_CLASSES: Record<ProjectStatus, string> = {
  requested: 'bg-status-requested text-status-requested-fg',
  scheduled: 'bg-status-scheduled text-status-scheduled-fg',
  en_route: 'bg-status-enroute text-status-enroute-fg',
  on_site: 'bg-status-onsite text-status-onsite-fg',
  punch: 'bg-status-punch text-status-punch-fg',
  pending_closeout: 'bg-status-pendingcloseout text-status-pendingcloseout-fg',
  complete: 'bg-status-complete text-status-complete-fg',
  blocked: 'bg-status-blocked text-status-blocked-fg',
  cancelled: 'bg-status-cancelled text-status-cancelled-fg',
};

export function StatusBadge({
  status,
  className,
}: {
  status: ProjectStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        STATUS_CLASSES[status],
        className,
      )}
    >
      {PROJECT_STATUS_LABELS[status]}
    </span>
  );
}
